export const entryMarks = Array.from(Array(15), (_, index) => (index + 1).toString());

export const headerItem = [
  'GMT +03',
  'Контрагент',
  'Тариф',
  'Сессия',
  'Вход',
  'Выход',
  ...entryMarks,
  'Инструктор',
  'Контроллер',
]